import DateFormat from '../common/dateFormat/DateFormat';

const INITIAL_STATE = {
	aguardando: false,
	registro: {},
	modoTela: 'lista',
	filtro: {
		data_inicial: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAnterior(30)),
		data_final: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual())
	},
	lista: [],
	listaFornecedor: [],
	listaEmbalagem: [],
	listaEstoqueLocal: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'EMBALAGEM_AVARIADA_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'EMBALAGEM_AVARIADA_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};

        case 'EMBALAGEM_AVARIADA_FILTRO':
            return {
				...state,
				filtro: action.payload.filtro
			};

        case 'EMBALAGEM_AVARIADA_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

        case 'EMBALAGEM_AVARIADA_FORNECEDOR_SELECT_LISTADO':
			return {
				...state,
				listaFornecedor: action.payload.data
			};

        case 'EMBALAGEM_AVARIADA_EMBALAGEM_SELECT_LISTADO':
			return {
				...state,
				listaEmbalagem: action.payload.data
			};

        case 'EMBALAGEM_AVARIADA_ESTOQUE_LOCAL_SELECT_LISTADO':
			return {
				...state,
				listaEstoqueLocal: action.payload.data
			};

        default:
            return state;
    }
}
